var initialState = {
  loaded: false,
  initialLoadPending: true,
  loading: false,
  error: false
};
export default initialState;